<template>
	<v-dialog v-model="userStore.dialogInfo.dialogOn" persistent width="500">
		<v-card>
			<!-- # Success Dialog Header -->
			<v-toolbar v-if="userStore.dialogInfo.title == 'Success'" class="justify-center" elevation="1">
				<v-spacer />
				<v-icon color="primary" large> mdi-check-circle </v-icon>
				<v-spacer />
			</v-toolbar>

			<!-- # Error Dialog Header -->
			<v-toolbar v-else-if="userStore.dialogInfo.type == 'error'" class="justify-center" elevation="1">
				<v-spacer />
				<v-icon color="error" large> mdi-alert-circle </v-icon>
				<v-spacer />
			</v-toolbar>

			<!-- # Other Dialog Header -->
			<v-toolbar v-else dark :color="userStore.dialogInfo.type">
				{{ userStore.dialogInfo.title }}
			</v-toolbar>

			<!-- ## Message Body -->
			<v-card-text class="textContainer">
				{{ userStore.dialogInfo.message }}
			</v-card-text>

			<v-divider />

			<!-- ## Actions -->
			<v-card-actions>
				<v-spacer />
				<v-btn :color="userStore.dialogInfo.type" text @click="userStore.closeDialogBox()">
					{{ userStore.dialogInfo.buttonTitle }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup>
	import { useUserStore } from '../stores/user'

	const userStore = useUserStore()
</script>

<style scoped>
	.textContainer {
		padding: 25px !important;
		font-size: 1em;
		white-space: pre-line;
	}
</style>
